import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ILeaders {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  pre_title?: string;
  pre_title_color?: string;
  title?: string;
  title_start_color?: string;
  title_end_color?: string;
  title_gradient_angle?: string;
  scroll_frequency?: number;
  description_box_start_color?: string;
  description_box_end_color?: string;
  description_box_gradient_angle?: string;
  description_section_pre_title?: string;
  description_section_pre_title_color?: string;
  description_section_title?: string;
  description_section_title_color?: string;
  description_section_description?: string;
  description_section_description_text_color?: string;
  variant?: string;
  metadata?: any[];
  status?: boolean;
}

export async function createLeaders(payload: Partial<ILeaders>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.LEADERS.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateLeaders(id: number, payload: Partial<ILeaders>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.LEADERS.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
